export const gbp = (n, digits = 0) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: digits, minimumFractionDigits: digits }).format(n || 0);

export const longDate = (iso) =>
  iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "";

export const shortDate = (iso) =>
  iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "";

export const applicantUrl = (token) => `${window.location.origin}/a/${token}`;
export const applyUrl = (propertyKey) => `${window.location.origin}/apply/${propertyKey}`;
export const criteriaUrl = (token) => `${window.location.origin}/criteria/${token}`;

/** sk_live_••••••••••••••••Boi6: prefix up to the last "_", 16 dots, last 4 characters. */
export const maskKey = (k = "") => `${k.slice(0, k.lastIndexOf("_") + 1)}${"•".repeat(16)}${k.slice(-4)}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}
